import { B300, N500, N700 } from '@atlaskit/theme/colors';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import {
  ICON_STATES,
  SecondaryProductDisplayPropsType,
  SecondaryProductSelectionContainerPropsType
} from '../../model';
import { ProductIcon } from '../icon';
import { modalMessagesByProductKey } from '../messages';
import { CharlieDisplayFontStack, CharlieTextFontStack } from '../styled';

export function SecondaryProductDisplayModalView({
  productKey,
  selected = false,
  onSelect = () => undefined,
  btnId
}: SecondaryProductDisplayPropsType) {
  return (
    <SecondaryProductSelectionContainer
      selected={selected}
      onClick={() => onSelect()}
      aria-selected={selected}
      data-testid={`select-btn-${btnId}`}
    >
      <SecondaryProductSelectionColumn>
        <SecondaryProductContainer>
          <ProductIcon
            productKey={productKey}
            iconState={ICON_STATES.MODAL_PRODUCT}
          />
          <SecondaryProductHeading>
            <FormattedMessage {...modalMessagesByProductKey[productKey].name} />
          </SecondaryProductHeading>
        </SecondaryProductContainer>
        <SecondaryProductDescription>
          <FormattedMessage
            {...modalMessagesByProductKey[productKey].description}
          />
        </SecondaryProductDescription>
      </SecondaryProductSelectionColumn>
    </SecondaryProductSelectionContainer>
  );
}

const SecondaryProductSelectionContainer = styled.button<SecondaryProductSelectionContainerPropsType>`
  display: flex;
  flex-direction: row;
  max-width: 50%;
  width: 100%;
  min-height: 130px;
  padding: ${({ selected }: SecondaryProductSelectionContainerPropsType) =>
    selected ? `30px` : '31px'};
  border: ${({ selected }: SecondaryProductSelectionContainerPropsType) =>
    selected ? `2px solid ${B300} !important` : '1px solid #cdd1d8'};
  border-radius: 10px;
  box-sizing: border-box;
  background-color: transparent;
  text-align: left;

  @media (max-width: 1160px) {
    flex-direction: column;
    align-items: flex-end;
  }

  @media (max-width: 400px) {
    padding: 18px 12px;
  }

  &:hover,
  &:focus,
  &:focus-visible {
    padding: 30px;
    border: 2px solid ${B300} !important;
  }
`;

const SecondaryProductSelectionColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

const SecondaryProductContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: -5px;
  margin-bottom: 14px;
`;

const SecondaryProductHeading = styled.h2`
  margin: 0 0 0 5px;
  font-size: 24px !important;
  line-height: 24px !important;

  span {
    font-family: ${CharlieDisplayFontStack};
    font-size: 24px;
    line-height: 24px;
    font-weight: 400;
    color: ${N700};
    letter-spacing: 0;
  }
`;

const SecondaryProductDescription = styled.p`
  margin: 0;
  font-size: 14px !important;
  line-height: 18px !important;

  span {
    font-family: ${CharlieTextFontStack};
    font-size: 14px;
    color: ${N500};
    font-weight: 400;
    letter-spacing: 0;
    line-height: 18px;
  }
`;
